<template>
    <div class="header">
        <div class="top-navigation--canvasser flex justify-between content-center md:p-2">
            <div class="top-navigation__left z-999">
                <!-- Large logo -->
                <router-link :to="{ name: 'account.dashboard'}">
                    <img
                        class="hidden lg:block top-navigation__left--logo-img"
                        src="@/assets/images/logos/freddies_flowers_stacked.svg"
                        alt="Freddie's Flowers"/>
                </router-link>
            </div>

            <div class="top-navigation__center text-center lg:flex-1 lg:content-start">
                <!-- Small logo -->
                <router-link
                             :to="{ name: 'account.dashboard'}">
                    <img
                        class="block lg:hidden top-navigation__center--logo-img"
                        src="@/assets/images/logos/freddies_flowers_logo_horizontal.svg"
                        alt="Freddie's Flowers"/>
                </router-link>
            </div>

            <div class="top-navigation__right">
                <login-link-canvasser/>
                <help-button class="hidden lg:block"></help-button>
            </div>
        </div>
        <div class="divider-brown--top divider--not-fixed"></div>
    </div>
</template>
<script>

import HelpButton from '@/components/structure/navigation/navigation/HelpButton';
import LoginLinkCanvasser from '@/components/structure/navigation/navigation/LogInLinkCanvasser';

export default {
    name: 'TopCanvasserNavigation',
    components: {
        LoginLinkCanvasser,
        HelpButton,
    },
};
</script>
